import { useRef } from 'react'
import { RECAPTCHA_V3_SITE_KEY } from 'Common/constants'

function useRecaptcha() {
  const ref = useRef()

  return {
    props: { ref, sitekey: RECAPTCHA_V3_SITE_KEY },
    executeAsync: () => ref.current?.executeAsync() ?? Promise.resolve(''),
  }
}

export default useRecaptcha
